import { defineStore } from 'pinia';
import { ref } from 'vue';

export type Breadcrumb = {
  name: string;
  to?: string;
};

export const useBreadcrumbStore = defineStore('breadcrumb', () => {
  const breadcrumbs = ref<Breadcrumb[]>([]);

  const setBreadcrumbs = (newBreadcrumbs: Breadcrumb[]) => {
    breadcrumbs.value = newBreadcrumbs;
  };

  const clearBreadcrumbs = () => {
    breadcrumbs.value = [];
  };

  return {
    breadcrumbs,
    setBreadcrumbs,
    clearBreadcrumbs,
  };
}); 